import {
  AirplaneLandingIcon,
  AirplaneTakeoffIcon,
  ArrowsCounterClockwiseIcon,
  CalendarBlankIcon,
  HandbagIcon,
  TruckIcon,
} from '@phosphor-icons/react'

import { ChatAlertIcon, PackageShippedIcon, shipmentStatuses } from '@reveni-io/reveni-ui'

import { sectionIds, viewTypes } from '@/common/components/FilterViews/constants'
import { parcelDirections } from '@/parcels/constants'

export const filterNames = {
  query: 'query',
  orderBy: 'orderBy',
  parcelType: 'parcelType',
  shipmentStatus: 'shipmentStatus',
  shipmentNormalizedTrackingStatus: 'shipmentNormalizedTrackingStatus',
  shipmentOrigin: 'shipmentOrigin',
  shipmentDestination: 'shipmentDestination',
  shipmentLocation: 'shipmentLocation',
  creationDate: 'creationDate',
  creationDateStart: 'creationDateStart',
  creationDateEnd: 'creationDateEnd',
  shipmentCreationDaysGte: 'shipmentCreationDaysGte',
  shipmentCreationDaysLte: 'shipmentCreationDaysLte',
  shipmentException: 'shipmentException',
  pageSize: 'shipmentsPageSize',
  shipmentsCursor: 'shipmentsCursor',
  shipmentsCarrier: 'shipmentsCarrier',
  shipmentsCarrierService: 'shipmentsCarrierService',
  shipmentExternalCreated: 'shipmentExternalCreated',
  shipmentExternalCreatedGte: 'shipmentExternalCreatedGte',
  shipmentExternalCreatedLte: 'shipmentExternalCreatedLte',
  shipmentExternalCreatedDaysGte: 'shipmentExternalCreatedDaysGte',
  shipmentExternalCreatedDaysLte: 'shipmentExternalCreatedDaysLte',
  shipmentPackedAt: 'shipmentPackedAt',
  shipmentPackedAtGte: 'shipmentPackedAtGte',
  shipmentPackedAtLte: 'shipmentPackedAtLte',
  shipmentPackedAtDaysGte: 'shipmentPackedAtDaysGte',
  shipmentPackedAtDaysLte: 'shipmentPackedAtDaysLte',
  shipmentReadyDate: 'shipmentReadyDate',
  shipmentReadyDateGte: 'shipmentReadyDateGte',
  shipmentReadyDateLte: 'shipmentReadyDateLte',
  shipmentReadyDateDaysGte: 'shipmentReadyDateDaysGte',
  shipmentReadyDateDaysLte: 'shipmentReadyDateDaysLte',
  shipmentShippedAt: 'shipmentShippedAt',
  shipmentShippedAtGte: 'shipmentShippedAtGte',
  shipmentShippedAtLte: 'shipmentShippedAtLte',
  shipmentShippedAtDaysGte: 'shipmentShippedAtDaysGte',
  shipmentShippedAtDaysLte: 'shipmentShippedAtDaysLte',
  shipmentDeliveredAt: 'shipmentDeliveredAt',
  shipmentDeliveredAtGte: 'shipmentDeliveredAtGte',
  shipmentDeliveredAtLte: 'shipmentDeliveredAtLte',
  shipmentDeliveredAtDaysGte: 'shipmentDeliveredAtDaysGte',
  shipmentDeliveredAtDaysLte: 'shipmentDeliveredAtDaysLte',
  claimStatus: 'claimStatus',
  claimType: 'claimType',
  claimCreatedAt: 'claimCreatedAt',
  claimCreatedAtGte: 'claimCreatedAtGte',
  claimCreatedAtLte: 'claimCreatedAtLte',
  claimCreatedAtDaysGte: 'claimCreatedAtDaysGte',
  claimCreatedAtDaysLte: 'claimCreatedAtDaysLte',
}

const commonFilters = [
  { name: filterNames.query, type: 'string', backendName: 'search' },
  { name: filterNames.orderBy, type: 'string', defaultValue: '-created_at', backendName: 'ordering' },
  { name: filterNames.shipmentStatus, type: 'array', backendName: 'status' },
  { name: filterNames.shipmentNormalizedTrackingStatus, type: 'array', backendName: 'normalized_tracking_status' },
  { name: filterNames.shipmentOrigin, type: 'array', backendName: 'origin' },
  { name: filterNames.shipmentDestination, type: 'array', backendName: 'destination' },
  { name: filterNames.creationDateStart, type: 'string', backendName: 'created_at__gte' },
  { name: filterNames.creationDateEnd, type: 'string', backendName: 'created_at__lte' },
  { name: filterNames.shipmentException, type: 'string', backendName: 'with_exception' },
  { name: filterNames.pageSize, type: 'number', backendName: 'page_size', defaultValue: 25 },
  { name: filterNames.shipmentCreationDaysGte, type: 'number', backendName: 'created_at_days__gte' },
  { name: filterNames.shipmentCreationDaysLte, type: 'number', backendName: 'created_at_days__lte' },
  { name: filterNames.shipmentsCursor, type: 'string', backendName: 'cursor' },
  { name: filterNames.shipmentsCarrier, type: 'array', backendName: 'carrier' },
  { name: filterNames.shipmentsCarrierService, type: 'string', backendName: 'carrier_service' },
  { name: filterNames.shipmentShippedAtGte, type: 'string', backendName: 'shipped_at__gte' },
  { name: filterNames.shipmentShippedAtLte, type: 'string', backendName: 'shipped_at__lte' },
  { name: filterNames.shipmentShippedAtDaysGte, type: 'number', backendName: 'shipped_at_days__gte' },
  { name: filterNames.shipmentShippedAtDaysLte, type: 'number', backendName: 'shipped_at_days__lte' },
  { name: filterNames.shipmentDeliveredAtGte, type: 'string', backendName: 'delivered_at__gte' },
  { name: filterNames.shipmentDeliveredAtLte, type: 'string', backendName: 'delivered_at__lte' },
  { name: filterNames.shipmentDeliveredAtDaysGte, type: 'number', backendName: 'delivered_at_days__gte' },
  { name: filterNames.shipmentDeliveredAtDaysLte, type: 'number', backendName: 'delivered_at_days__lte' },
  { name: filterNames.shipmentLocation, type: 'string', backendName: 'location_id' },
  { name: filterNames.claimStatus, type: 'array', backendName: 'claim_status' },
  { name: filterNames.claimType, type: 'array', backendName: 'claim_type' },
  { name: filterNames.claimCreatedAtGte, type: 'string', backendName: 'claim_created_at__gte' },
  { name: filterNames.claimCreatedAtLte, type: 'string', backendName: 'claim_created_at__lte' },
  { name: filterNames.claimCreatedAtDaysGte, type: 'number', backendName: 'claim_created_at_days__gte' },
  { name: filterNames.claimCreatedAtDaysLte, type: 'number', backendName: 'claim_created_at_days__lte' },
]

const outboundOnlyFilters = [
  { name: filterNames.parcelType, type: 'array' },
  { name: filterNames.shipmentExternalCreatedGte, type: 'string', backendName: 'external_created__gte' },
  { name: filterNames.shipmentExternalCreatedLte, type: 'string', backendName: 'external_created__lte' },
  { name: filterNames.shipmentExternalCreatedDaysGte, type: 'number', backendName: 'external_created_days__gte' },
  { name: filterNames.shipmentExternalCreatedDaysLte, type: 'number', backendName: 'external_created_days__lte' },
  { name: filterNames.shipmentPackedAt, type: 'string', backendName: 'packed_at' },
  { name: filterNames.shipmentPackedAtGte, type: 'string', backendName: 'packed_at__gte' },
  { name: filterNames.shipmentPackedAtLte, type: 'string', backendName: 'packed_at__lte' },
  { name: filterNames.shipmentPackedAtDaysGte, type: 'number', backendName: 'packed_at_days__gte' },
  { name: filterNames.shipmentPackedAtDaysLte, type: 'number', backendName: 'packed_at_days__lte' },
  { name: filterNames.shipmentReadyDateGte, type: 'string', backendName: 'ready_at__gte' },
  { name: filterNames.shipmentReadyDateLte, type: 'string', backendName: 'ready_at__lte' },
  { name: filterNames.shipmentReadyDateDaysGte, type: 'number', backendName: 'ready_at_days__gte' },
  { name: filterNames.shipmentReadyDateDaysLte, type: 'number', backendName: 'ready_at_days__lte' },
]

const outboundFilters = [...commonFilters, ...outboundOnlyFilters]

const inboundFilters = [...commonFilters]

const outboundSectionIds = {
  shipment: 'shipment',
  order: 'order',
  origin: 'origin',
  destination: 'destination',
  statusUpdates: 'statusUpdates',
  logistics: 'logistics',
  claims: 'claims',
}

export const outboundSections = [
  {
    label: 'Envío',
    id: outboundSectionIds.shipment,
    Icon: PackageShippedIcon,
  },
  {
    label: 'Pedido',
    id: outboundSectionIds.order,
    Icon: HandbagIcon,
  },
  {
    label: 'Origen',
    id: outboundSectionIds.origin,
    Icon: AirplaneTakeoffIcon,
  },
  {
    label: 'Destino',
    id: outboundSectionIds.destination,
    Icon: AirplaneLandingIcon,
  },
  {
    label: 'Actualizaciones de estado',
    id: outboundSectionIds.statusUpdates,
    Icon: ArrowsCounterClockwiseIcon,
  },
  {
    label: 'Logística',
    id: outboundSectionIds.logistics,
    Icon: TruckIcon,
  },
  {
    label: 'Incidencias',
    id: outboundSectionIds.claims,
    Icon: ChatAlertIcon,
  },
]

export const outboundFilterTypes = [
  { label: 'Tipo de envío', value: filterNames.parcelType, section: outboundSectionIds.shipment },
  { label: 'Estado del envío', value: filterNames.shipmentStatus, section: outboundSectionIds.shipment },
  {
    label: 'Último estado de seguimiento',
    value: filterNames.shipmentNormalizedTrackingStatus,
    section: outboundSectionIds.shipment,
  },
  { label: 'Alertas pendientes', value: filterNames.shipmentException, section: outboundSectionIds.shipment },
  { label: 'Fecha de pedido', value: filterNames.shipmentExternalCreated, section: outboundSectionIds.order },
  { label: 'Región de origen', value: filterNames.shipmentOrigin, section: outboundSectionIds.origin },
  { label: 'Ubicación de origen', value: filterNames.shipmentLocation, section: outboundSectionIds.origin },
  { label: 'Región de destino', value: filterNames.shipmentDestination, section: outboundSectionIds.destination },
  { label: 'Fecha de creación', value: filterNames.creationDate, section: outboundSectionIds.statusUpdates },
  { label: 'Fecha de empaquetado', value: filterNames.shipmentPackedAt, section: outboundSectionIds.statusUpdates },
  {
    label: 'Fecha de listo para envío',
    value: filterNames.shipmentReadyDate,
    section: outboundSectionIds.statusUpdates,
  },
  { label: 'Fecha de envío', value: filterNames.shipmentShippedAt, section: outboundSectionIds.statusUpdates },
  { label: 'Fecha de entrega', value: filterNames.shipmentDeliveredAt, section: outboundSectionIds.statusUpdates },
  { label: 'Transportista', value: filterNames.shipmentsCarrier, section: outboundSectionIds.logistics },
  { label: 'Servicio de logística', value: filterNames.shipmentsCarrierService, section: outboundSectionIds.logistics },
  { label: 'Estado de la incidencia', value: filterNames.claimStatus, section: outboundSectionIds.claims },
  { label: 'Tipo de incidencia', value: filterNames.claimType, section: outboundSectionIds.claims },
  {
    label: 'Fecha de creación de la incidencia',
    value: filterNames.claimCreatedAt,
    section: outboundSectionIds.claims,
  },
]

const inboundSectionIds = {
  shipment: 'shipment',
  origin: 'origin',
  destination: 'destination',
  statusUpdates: 'statusUpdates',
  logistics: 'logistics',
  claims: 'claims',
}

export const inboundSections = [
  {
    label: 'Envío',
    id: inboundSectionIds.shipment,
    Icon: PackageShippedIcon,
  },
  {
    label: 'Origen',
    id: inboundSectionIds.origin,
    Icon: AirplaneTakeoffIcon,
  },
  {
    label: 'Destino',
    id: inboundSectionIds.destination,
    Icon: AirplaneLandingIcon,
  },
  {
    label: 'Actualizaciones de estado',
    id: inboundSectionIds.statusUpdates,
    Icon: CalendarBlankIcon,
  },
  {
    label: 'Logística',
    id: inboundSectionIds.logistics,
    Icon: TruckIcon,
  },
  {
    label: 'Incidencias',
    id: inboundSectionIds.claims,
    Icon: ChatAlertIcon,
  },
]

export const inboundFilterTypes = [
  { label: 'Estado del envío', value: filterNames.shipmentStatus, section: inboundSectionIds.shipment },
  {
    label: 'Último estado de seguimiento',
    value: filterNames.shipmentNormalizedTrackingStatus,
    section: inboundSectionIds.shipment,
  },
  { label: 'Alertas pendientes', value: filterNames.shipmentException, section: inboundSectionIds.shipment },
  { label: 'Región de origen', value: filterNames.shipmentOrigin, section: inboundSectionIds.origin },
  { label: 'Región de destino', value: filterNames.shipmentDestination, section: inboundSectionIds.destination },
  { label: 'Ubicación de destino', value: filterNames.shipmentLocation, section: inboundSectionIds.destination },
  { label: 'Fecha de creación', value: filterNames.creationDate, section: inboundSectionIds.statusUpdates },
  { label: 'Fecha de envío', value: filterNames.shipmentShippedAt, section: inboundSectionIds.statusUpdates },
  { label: 'Fecha de entrega', value: filterNames.shipmentDeliveredAt, section: inboundSectionIds.statusUpdates },
  { label: 'Transportista', value: filterNames.shipmentsCarrier, section: inboundSectionIds.logistics },
  { label: 'Servicio de logística', value: filterNames.shipmentsCarrierService, section: inboundSectionIds.logistics },
  { label: 'Estado de la incidencia', value: filterNames.claimStatus, section: inboundSectionIds.claims },
  { label: 'Tipo de incidencia', value: filterNames.claimType, section: inboundSectionIds.claims },
  { label: 'Fecha de creación de la incidencia', value: filterNames.claimCreatedAt, section: inboundSectionIds.claims },
]

export const outboundViewIds = {
  default: 'default',
  requested: 'requested',
  readyToSend: 'readyToSend',
  shipped: 'shipped',
  delivered: 'delivered',
  exceptions: 'exceptions',
}

const inboundViewIds = {
  default: 'default',
  requested: 'requested',
  shipped: 'shipped',
  delivered: 'delivered',
  exceptions: 'exceptions',
}

export const outboundDefaultViews = [
  {
    id: outboundViewIds.default,
    name: 'Todos los envíos',
    filters: {
      ordering: '-created_at',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: outboundViewIds.requested,
    name: 'Por preparar',
    filters: {
      status: [shipmentStatuses.requested],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: outboundViewIds.readyToSend,
    name: 'Listos para enviar',
    filters: {
      status: [shipmentStatuses.ready],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: outboundViewIds.shipped,
    name: 'En tránsito',
    filters: {
      status: [shipmentStatuses.shipped],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: outboundViewIds.delivered,
    name: 'Entregados',
    filters: {
      status: [shipmentStatuses.delivered],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: outboundViewIds.exceptions,
    name: 'Alertas',
    filters: {
      with_exception: 'true',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
]

const inboundDefaultViews = [
  {
    id: inboundViewIds.default,
    name: 'Todos los envíos',
    filters: {
      ordering: '-created_at',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: inboundViewIds.requested,
    name: 'Solicitados',
    filters: {
      status: [shipmentStatuses.requested],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: inboundViewIds.shipped,
    name: 'En tránsito',
    filters: {
      status: [shipmentStatuses.shipped],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: inboundViewIds.delivered,
    name: 'Entregados',
    filters: {
      status: [shipmentStatuses.delivered],
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: inboundViewIds.exceptions,
    name: 'Alertas',
    filters: {
      with_exception: 'true',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
]

export const parcelDirectionConfig = {
  [parcelDirections.outbound]: {
    filtersContextKey: 'parcelsOutboundFilters',
    viewType: viewTypes.shipmentsOutbound,
    showBulkActions: true,
    filters: outboundFilters,
    filterTypes: outboundFilterTypes,
    sections: outboundSections,
    defaultViews: outboundDefaultViews,
  },
  [parcelDirections.inbound]: {
    filtersContextKey: 'parcelsInboundFilters',
    viewType: viewTypes.shipmentsInbound,
    showBulkActions: false,
    filters: inboundFilters,
    filterTypes: inboundFilterTypes,
    sections: inboundSections,
    defaultViews: inboundDefaultViews,
  },
}
